import { useSyncExternalStore } from 'react';

/** The media query this hook follows. */
export const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
function subscribe(onStoreChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
  const mediaQuery = window.matchMedia(PREFERS_REDUCED_MOTION_QUERY);
  mediaQuery.addEventListener?.('change', onStoreChange);
  return () => mediaQuery.removeEventListener?.('change', onStoreChange);
}
function getSnapshot() {
  return typeof window !== 'undefined' && !!window.matchMedia?.(PREFERS_REDUCED_MOTION_QUERY).matches;
}

// The server cannot know the visitor's setting: it renders the full-motion
// markup and the client corrects it after hydration.
function getServerSnapshot() {
  return false;
}

/**
 * Whether the visitor asks for reduced motion (`prefers-reduced-motion:
 * reduce`), kept in sync with the setting. `false` on the server, during
 * hydration and where `matchMedia` is missing.
 */
export default function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}